//@flow

import env from '../../../../environment';
import {
  deleteCreator,
  getCreator,
  postCreator,
  putCreator,
} from '../../../../http';

export const endpoints = Object.freeze({
  GET_PICKUP_RATE: `${env.baseApiUrl}/im/admin/delivery/pickup-address/:adminRateId`,
  LIST_PICKUP_METHOD: `${env.baseApiUrl}/im/admin/delivery/pickup-method`,
  CREATE_PICKUP_RATE: `${env.baseApiUrl}/im/admin/delivery/pickup-address`,
  UPDATE_PICKUP_RATE: `${env.baseApiUrl}/im/admin/delivery/pickup-address/:adminRateId`,
  DELETE_PICKUP_RATE: `${env.baseApiUrl}/im/admin/delivery/pickup-address/:adminRateId`,
  UPDATE_ENBLAED_PICKUP_METHOD: `${env.baseApiUrl}/im/admin/delivery/pickup-method`,
});

export const getPickupRateApi = getCreator(endpoints.GET_PICKUP_RATE);
export const getPickupMethodApi = getCreator(endpoints.LIST_PICKUP_METHOD);
export const createPickupRateApi = postCreator(endpoints.CREATE_PICKUP_RATE);
export const updatePickupRateApi = putCreator(endpoints.UPDATE_PICKUP_RATE);
export const deletePickupRateApi = deleteCreator(endpoints.DELETE_PICKUP_RATE);
export const updateEnabledPickupMethodApi = putCreator(
  endpoints.UPDATE_ENBLAED_PICKUP_METHOD
);
